<div class="table-container">
  <mat-table
    *ngIf="isLoading === false"
    [dataSource]="dataSource"
    matSort
    matSortActive="municipalityName"
    matSortDirection="asc"
    class="mat-table"
    matSortDisableClear
  >
    <ng-container matColumnDef="checkbox">
      <mat-header-cell *matHeaderCellDef>
        <div class="profile-data-group">
          <!-- TODO: Uncomment checkbox in the future for usability -->
          <!-- <mat-checkbox class="checkbox-label"> </mat-checkbox> -->
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="profile-data-group">
          <mat-checkbox [checked]="selection.isSelected(element)" (change)="$event ? selection.toggle(element) : null" class="checkbox-label"> </mat-checkbox>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef>{{ 'module.municipality.onboarding.statusLabel' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="active" *ngIf="!element.isDeactivated">{{ 'module.municipality.onboarding.aktivLabel' | translate }}</div>
        <div class="inactive" *ngIf="element.isDeactivated">{{ 'module.municipality.onboarding.inaktivLabel' | translate }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="municipalityNumber">
      <mat-header-cell *matHeaderCellDef>{{ 'module.municipality.onboarding.municipalityNumberLabel' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div [hidden]="!showRecentDataIcon(element.municipalityKey)" class="fa fa-circle"></div>
        {{ element.municipalityKey || '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="municipalityName">
      <mat-header-cell mat-sort-header="municipalityName" *matHeaderCellDef>{{
        'module.municipality.onboarding.municipalityNameLabel' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.name || '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="zipCode">
      <mat-header-cell *matHeaderCellDef>{{ 'module.municipality.onboarding.zipcodeLabel' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.zipCode || '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="creationDate">
      <mat-header-cell mat-sort-header="creationDate" *matHeaderCellDef>{{ 'module.municipality.onboarding.creationDateLabel' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="rolesContainer">
        {{ element.creationDate ? (element.creationDate | date: 'dd.MM.y') : '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="modifyDate">
      <mat-header-cell *matHeaderCellDef>{{ 'module.municipality.onboarding.modifiedDateLabel' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="name-container">
        <div class="user">
          {{ element.modifyUser || '-' }}
        </div>
        <div class="modify-date">
          {{ element.modifyDate ? (element.modifyDate | date: 'dd.MM.y') : '-' }}
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay" [ngClass]="{ selected: selection.isSelected(row) }"></mat-row>
  </mat-table>
  <div class="empty-search-container" *ngIf="dataSource.filteredData.length <= 0 && dataSource.filter !== ''">
    <app-svg-icon src="./assets/icons/empty-search.svg"></app-svg-icon>
    <p class="empty-search-title">{{ 'module.municipality.onboarding.emptySearchTitleLabel' | translate }}</p>
    <p class="empty-search-text">{{ 'module.municipality.onboarding.emptySearchTextLabel' | translate }}</p>
  </div>
</div>

<div class="footer">
  <div class="page-index-container">
    <p class="page-text">{{ 'module.municipality.onboarding.currentPageTextLabel' | translate }}</p>
    <div class="pageindex">{{ matPaginator.pageIndex + 1 }}</div>
  </div>
  <mat-paginator [hidden]="isLoading === true" #matPaginator [length]="count" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"> </mat-paginator>
</div>

<div class="loader-wrapper" *ngIf="isLoading === true">
  <span class="fa fa-spinner fa-spin fa-3x"></span>
</div>
